import { RootState } from 'utils/interfaces'

export const selectRobotTelemetry = (state: RootState) => state.robot.telemetry
export const selectRobotLoadingProgress = (state: RootState) => state.robot.loadingProgress
export const selectRobot = (state: RootState) => state.robot
export const selectRobotJobUploadingProgress = (state: RootState) => state.robot.jobInfo.uploadingProgress
export const selectRobotJob = (state: RootState) => state.robot.robotInfo?.job
export const selectRobotActiveMode = (state: RootState) => state.robot.robotInfo?.activeMode
